<div class="container d-lg-block d-none py-4">
  <div class="back-btn bg-primary" (click)="goBack()">
    <span class="material-symbols-outlined text-white"> arrow_back_ios_new </span>
  </div>
</div>

<!-- Points Summary -->
<fgb-points-summary-bar
  [backButtonLink]="marketplaceItemType.backLink"
  [marketplaceItemGroup]="marketplaceItemType.group"
></fgb-points-summary-bar>

<fgbcl-marketplace-details [itemId]="id" [actionLabels]="actionLabels"></fgbcl-marketplace-details>
